import { Back, Front, LayerBackward, LayerForward, X, ArrowLeftRight } from "react-bootstrap-icons"
import { CSSProperties, useEffect, useState } from "react"
import useSelector from "./CanvasFeaturesCustomHooks/useSelector"
import { useStickerSectionStore } from "../EditorStore"

export default function CursorEditor() {
    const iconSize = "3vh"
    const [visible, setVisible] = useState(false)

    const { sendCanvasImageToBottom, sendCanvasImageToTop, moveSelectedDownOneLayer, moveSelectedUpOneLayer, deleteSelectedItem, flipSelectedImage } = useSelector()

    const isAtTop = useStickerSectionStore((state) => state.isAtTop)
    const isAtBottom = useStickerSectionStore((state) => state.isAtBottom)
    const isPortrait = useStickerSectionStore((state) => state.isPortrait)

    const currentSelectedCanvasImageRef = useStickerSectionStore(
        (state) => state.currentCanvasImageSelectedRef
    )

    useEffect(() => {
        const timeout = setTimeout(() => setVisible(true), 10)
        return () => clearTimeout(timeout)
    }, [])

    return (
        <div
            style={{
                position: "fixed",
                top: isPortrait ? "15%" : "0",
                left: isPortrait ? "50%" : "6.5vw",
                height: isPortrait ? "14%" : "50vh",
                transform: isPortrait ? "translate(-50%, -50%)" : "",
                zIndex: 9999,
                pointerEvents: "auto",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                border: "2px solid white",
                borderRadius: "10px",
                width: isPortrait ? "75%" : "7%",
                display: "flex",
                flexDirection: isPortrait ? "row" : "column",
                opacity: visible ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
                marginTop: "1vh"
            }}
        >
            <div
                onClick={() => sendCanvasImageToBottom(currentSelectedCanvasImageRef.current!)}
                style={buttonStyle("Back", isAtBottom, isPortrait)}
            >
                <Back size={iconSize} />
                <span className="sr-only">Back</span>
            </div>

            <div
                onClick={() => moveSelectedDownOneLayer(currentSelectedCanvasImageRef.current!)}
                style={buttonStyle("Send Backward", isAtBottom, isPortrait)}
            >
                <LayerBackward size={iconSize} />
                <span className="sr-only">Send Backward</span>
            </div>

            <div
                onClick={() => moveSelectedUpOneLayer(currentSelectedCanvasImageRef.current!)}
                style={buttonStyle("Bring Forward", isAtTop, isPortrait)}
            >
                <LayerForward size={iconSize} />
                <span className="sr-only">Bring Forward</span>
            </div>

            <div
                onClick={() => sendCanvasImageToTop(currentSelectedCanvasImageRef.current!)}
                style={buttonStyle("Front", isAtTop, isPortrait)}
            >
                <Front size={iconSize} />
                <span className="sr-only">Front</span>
            </div>

            <div
                onClick={() => flipSelectedImage(currentSelectedCanvasImageRef.current!)}
                style={buttonStyle("Flip", false, isPortrait)}
            >
                <ArrowLeftRight size={iconSize} />
                <span className="sr-only">Flip</span>
            </div>

            <div
                onClick={() => deleteSelectedItem(currentSelectedCanvasImageRef.current!)}
                style={buttonStyle("Close", false, isPortrait)}
            >
                <X size={iconSize} />
                <span className="sr-only">Close</span>
            </div>
        </div>
    )
}

function buttonStyle(label: string, disabled: boolean, isPortrait: boolean): CSSProperties {
    return {
        width: isPortrait ? "calc(100% / 6)" : "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRight: label === "Close" ? "none" : (isPortrait ? "1px solid black" : "0px"),
        borderBottom: label === "Close" ? "none" : (isPortrait ? "0px" : "1px solid black"),
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "background-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
        height: "100%",
        filter: "invert(1)",
        opacity: disabled ? 0.5 : 1,
        transform: "translateZ(0)",

    }
}
